/**
 * @generated SignedSource<<9342d53df5986426bf422e0dffd1a1a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserRole = "CLIENT" | "COACH" | "%future added value";
export type AdminUserRouteQuery$variables = {
  username: string;
};
export type AdminUserRouteQuery$data = {
  readonly user: {
    readonly email: string | null | undefined;
    readonly role: UserRole;
    readonly " $fragmentSpreads": FragmentRefs<"UserPage_user">;
  } | null | undefined;
};
export type AdminUserRouteQuery = {
  response: AdminUserRouteQuery$data;
  variables: AdminUserRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "username"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "username",
    "variableName": "username"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminUserRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserPage_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminUserRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "admin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "raw",
                "value": true
              }
            ],
            "kind": "ScalarField",
            "name": "trialExpiryDate",
            "storageKey": "trialExpiryDate(raw:true)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d761777c7630af7cfa0506d040288e6c",
    "id": null,
    "metadata": {},
    "name": "AdminUserRouteQuery",
    "operationKind": "query",
    "text": "query AdminUserRouteQuery(\n  $username: String!\n) {\n  user(username: $username) {\n    email\n    role\n    ...UserPage_user\n    id\n  }\n}\n\nfragment UpdateTrialExpirationDateDialog_user on User {\n  id\n  trialExpiryDate(raw: true)\n}\n\nfragment UserDetails_user on User {\n  id\n  email\n  admin\n  role\n  trialExpiryDate(raw: true)\n  ...UpdateTrialExpirationDateDialog_user\n}\n\nfragment UserPage_user on User {\n  displayName\n  ...UserDetails_user\n}\n"
  }
};
})();

(node as any).hash = "292054d6b06bd1a633202906a7ff2f36";

export default node;
